import React from "react";
import { createRoot } from "react-dom/client";
import ContactTechQueryIsland from "./ContactTechQueryIsland";

const mountNode = document.getElementById("contact-tech-query-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<ContactTechQueryIsland config={config} />);
  }
}
